module.exports = __webpack_public_path__ + "img/album16_03.50a0fd0c.jpg";